import { render, staticRenderFns } from "./CardHorizontal.vue?vue&type=template&id=22edc422&scoped=true&"
import script from "./CardHorizontal.vue?vue&type=script&lang=js&"
export * from "./CardHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./CardHorizontal.vue?vue&type=style&index=0&id=22edc422&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22edc422",
  null
  
)

export default component.exports